import {
  Box, Center, Image, Text,
} from "@chakra-ui/react"
import React from "react"
import { PHONE_CONTAINER_QUERY } from "utilities/constants"

type Props = {
  qrCodeUrl: string
  qrCodeText: string
}

const QRCode = ({ qrCodeUrl, qrCodeText }: Props) => (
  <Box px={2} w={140} textAlign="center" sx={{ [PHONE_CONTAINER_QUERY]: { w: "190px" } }}>
    <Center>
      <Image
        src={qrCodeUrl}
        width={100}
        height={100}
        alt="QR Code"
        mb={3}
        sx={{ [PHONE_CONTAINER_QUERY]: { w: "150px", h: "150px" } }}
      />
    </Center>
    <Text fontSize="xs">{qrCodeText}</Text>
  </Box>
)

export default QRCode
